import dynamic from "next/dynamic"
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
// import Link from "next/link";
import { count, getSetting, isDefined, stripTags } from "../../config/helpers";
import { useSelector } from "react-redux";
import useWindowSize from "../../_hooks/useWindowSize";
// import ImageTile from "../Home2/HomeComponent2/ImageTile";
import ParseHtml from "../../Custom/ParseHtml";

const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));
// const Home = dynamic(() => import("../../Components/Home/Home"));
// const HomeCategoryTiles = dynamic(() => import("../../Components/Home/HomeCategoryTiles"));
// const HomeDescription = dynamic(() => import("../../Components/Home/HomeDescription"));
// const HomeStatistics = dynamic(() => import("@components/Components/HomeComponent/HomeStatistics"));
const HomeProductCarousel = dynamic(() => import("@components/Components/HomeComponent/HomeProductCarousel"));
const HomeCategories = dynamic(() => import("../HomeComponent/HomeCategories"));


const LandingPageLayout = ({ place, places, parent_categories,template_page_settings,layout,tabs,type,categories, extras}) => {

    const lay = getSetting(
        template_page_settings,
        "layout",
        "wide"
    );

    const { home_grid_columns }= template_page_settings;
        // console.log(categories)
    const { agent, template_page_content } = useSelector((state) => state.globalReducer);
    const { isMobile } = agent;
    const screensize = useWindowSize();
    
    const page_content = template_page_content[type];
    return (
        <>
            <BoxContainer className="mt-4" template_page_settings={template_page_settings}>
                <Box
                    className="mt-2 mb-4" 
                    sx={{
                    '& p': {
                        fontSize: 16
                    },
                    '& h3': {
                        fontSize: 24,
                        fontWeight: 700,
                        marginTop: 2

                    }
                }}>
                    <Typography className="f-size_5 pr-3 mb-2" component="h1" variant="h1">{place.meta_title}</Typography>
                    <Typography className="pl-3 pr-3 mb-3"><ParseHtml html={stripTags(place.desc1)}/></Typography>
                </Box>

                {places && count(places) > 0 ? (
                    <>
                        <ul className="mb-3 list-disc pl-3">
                            {places?.map((place, idx) => (
                                <li key={place.place_id}>{place.name}</li>
                            ))}
                        </ul>
                    </>
                ) : null}
                {/* <Home homeData={props} /> */}

                {/* <HomeCategoryTiles isMobile={isMobile} parent_categories={parent_categories}/> */}
                <HomeCategories
                    categories={categories}
                    home_grid_columns={home_grid_columns}
                />
                
                {/* <HomeDescription /> */}

                <Grid className="pl-3 pr-3" spacing={1} container>
                    <Grid item xs={12} lg={6} >
                        <Box
                            className="mt-2 mb-4" 
                            sx={{
                            '& p': {
                                fontSize: 16
                            },
                            '& h3': {
                                fontSize: 24,
                                fontWeight: 700,
                                marginTop: 2

                            }
                        }}>
                            <ParseHtml html={place.desc2}/>
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Box
                            className="mt-2 mb-4" 
                            sx={{
                            '& p': {
                                fontSize: 16
                            },
                            '& h3': {
                                fontSize: 24,
                                fontWeight: 700,
                                marginTop: 2

                            }
                        }}>
                            <ParseHtml html={place.desc3}/>
                        </Box>
                    </Grid>
                </Grid>

            </BoxContainer>

            {/* {page_content.statistics_image && <Box>
                {screensize.width < 1200 || (!isDefined(screensize.width) && isMobile) ? <HomeStatistics type="mobile"/> : <HomeStatistics layout={layout} screensize={screensize} isMobile={isMobile} type="desktop" />}
            </Box>} */}

            <BoxContainer className="mt-4" template_page_settings={template_page_settings}>
                {
                    isDefined(tabs) && count(Object.keys(tabs)) > 0 && (
                        <HomeProductCarousel 
                            tabs={tabs}
                            data={{place, template_page_settings,parent_categories,layout,tabs, type, extras}}
                        />
                    )
                }
                <Box
                    className="mt-2 mb-4" 
                    sx={{
                    '& p': {
                        fontSize: 16
                    },
                    '& h3': {
                        fontSize: 24,
                        fontWeight: 700,
                        marginTop: 2

                    }
                }}>
                    <ParseHtml html={place.desc4}/>
                </Box>

            </BoxContainer>

        </>
    )
}

export default LandingPageLayout